// Module
var code = "<div class=\"reports\" ng-class=\"{'no-sidebar' : $ctrl.$state.includes('reports.analysis') || $ctrl.$state.includes('reports.coaching') || $ctrl.$state.includes('reports.financialAccounts.show.entries') }\"> <reports-sidebar></reports-sidebar> <ui-view></ui-view> </div> ";
// Exports
module.exports = code;